import React from 'react';
import {
  ORDER_PHASE_DELIVERING,
  PICKUP_STATUS,
  MODIFY_ORDER_TYPE_PROMOTION,
  ORDER_PHASE,
  ORDER_TYPE_DELIVERY
} from '../../../constants';
import { changeOrderType } from '../OrderStatus.services';
import { useAppSelector } from '../../../redux/hook';

type OrderStatusFooterProps = {
  order: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function OrderStatusFooter({ order, setIsLoading }: OrderStatusFooterProps) {
  const { support } = useAppSelector((state) => state.shopReducer);
  const { secondaryColor, cancel: { disabled: disabledCancel }, delivery } =
    useAppSelector((state) => state.configurationReducer);

  if (!order) return null;

  const {
    status,
    cancellableWithRefundAndPromo,
    pickupStatus,
    numeroDep,
    orderType
  } = order;

  const phone = numeroDep || support?.number;
  const orderNotCurrentlySupported = pickupStatus === PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED;
  const refundReduction = delivery?.emergency?.refundReduction;
  const isCancelableStatus = [ORDER_PHASE.PREPARING, ORDER_PHASE.CONTACTING].includes(status);
  const isRefundCancelable = isCancelableStatus && !disabledCancel && cancellableWithRefundAndPromo && orderNotCurrentlySupported && orderType === ORDER_TYPE_DELIVERY;

  const ContactButton: React.FC<{ phone: string }> = ({ phone }) => (
    <div className="button-bottom-modal" onClick={() => window.open(`tel:${phone}`)}>
      <p className="text-muted mb-0 label">Contactez le livreur en cas de problème</p>
      <p className="text-muted">{phone}</p>
    </div>
  );

  if (isRefundCancelable) {
    return (
      <div
        className="button-bottom-modal"
        onClick={async () => {
          await changeOrderType(setIsLoading, order, MODIFY_ORDER_TYPE_PROMOTION.REFUND, null, refundReduction);
        }}
      >
        <i className="fas fa-times-circle fa-2x" style={{ color: secondaryColor }} />
        <p className="text-muted">Annuler la commande</p>
      </div>
    );
  }


  if (status === ORDER_PHASE_DELIVERING && phone) {
    return <ContactButton phone={phone} />;
  }

  return null;
}
